export const CARD_COLORS = {
  light: 'light',
  ghost: 'ghost',
}

export const CARD_BACKGROUND_COLORS = {
  light: '#f7f7f7',
  ghost: 'rgba(255, 255, 255, 0.1)',
  transparent: 'transparent',
  white: '#fff',
}
